module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildings"
    }
  }, [_c('el-row', {
    staticClass: "headLine"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goInner
    }
  }, [_vm._v("新建")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headright"
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "标题搜索",
      "size": "small"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('RuleList', {
    ref: "ruleColumn"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-0d57f4a9"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/rule/list/index.vue
// module id = 1412
// module chunks = 1